import React, { Component,useState,useEffect } from 'react';
import CountUp from 'react-countup';
import Datepicker from '../../common/datepicker';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from '../../../config.js'
import DynamicTable from '../../DynamicTable.js';

import DataTable from 'react-data-table-component';




const Permission = (props) => {


    const [formData, setFormData] = useState({
        permission_date: '',
        permission_hours: '',
        permission_status:'',
        reason:"",
        });
        const [sample, setlist] = useState([]); 

        const [loading, setLoading] = useState(false);
        const [error, setError] = useState(null);
        
        const [setform, setForm] = useState([]);
        const [settype, setType] = useState([]);
        const [sethour, setHour] = useState([]);
        const [setcount, setCount] = useState([]);

        const [table, setTable] = useState([]);
       

  const handleChange = (e) => {
  
    const { name, value } = e.target;
    setFormData({
    ...formData,
    [name]: value,
    });
    };

 
  
    useEffect(() => {
      
      axios
        .get(API_BASE_URL+'/permission', {
          headers: 
          { 
            Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
        }
        })
        .then((response) => {
          setTable(response.data.data.table);
          setCount(response.data.data.count[0].count);

        
          setLoading(false);
        })
        .catch((error) => {
        setError(error.message);
        setLoading(false);
        });
    }, []);

    useEffect(() => {
      
      axios
        .get(API_BASE_URL+'/permission_form', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
          }
        })
        .then((response) => {
          setForm(response.data.data.date);
          setType(response.data.data.permission_type);
          setHour(response.data.data.permission_hours);

          
          console.log("welceome");
          console.log(response.data.data.permission_hours);
          setLoading(false);
        })
        .catch((error) => {
        setError(error.message);
        setLoading(false);
        });
    }, []);
const handleSubmit =  async (e) => {

    e.preventDefault(); // Prevent the default form submission
    
    console.log('Form submitted:', formData);
    
    
    
    axios.post(API_BASE_URL+'/add_permission' ,formData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

      'Content-Type': 'application/json', // Ensure JSON data is sent
    },
  }).then(response => {
       //  console.log(response.data);
            //  console.log(response.data.message);
            // })
            var status =response.data.status;
                if (status=='success')
                {
                    toast.success(response.data.message, {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        });
                        setTimeout(() => {
                          window.location.reload(); // Reload the page after delay
                        }, 3000);
                       
                }
               else if (status=='error')
                  {
                      toast.error(response.data.message, {
                          position: "bottom-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: "colored",
                          });
                          // setTimeout(() => {
                          //   window.location.reload(); // Reload the page after delay
                          // }, 3000);
                         
                  }
               
            }).catch(error => {
            
                // console.log(error);
                // console.log(error.response.data.message);
                toast.error(error.response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
             });
    
    
    
    
    };






const columns = [
  {
    name: 'Employee Name',
    selector: row => row['Employee Name'],
    sortable: true,
  },
  {
    name: 'Permission Date',
    selector: row => row['Permission Date'],
    sortable: true,
  },
  {
    name: 'Permission Hours',
    selector: row => row['Permission Hours'],
    sortable: true,
  },
  {
    name: 'Permission Type',
    selector: row => row['Permission Type'],
    sortable: true,
  },
  {
    name: 'Reason',
    selector: row => row['Reason'],
    wrap: true,
  },
  {
    name: 'Status',
    selector: row => row['Status'],
    sortable: true,
    cell: row => {
      if (row['Status'] === 'Approved')
        return <span className="badge badge-success">Approved</span>;
      if (row['Status'] === 'Rejected')
        return <span className="badge badge-danger">Rejected</span>;
      return <span className="badge badge-warning">Pending</span>;
    }
  }
];


const { fixNavbar, statisticsOpen, statisticsClose } = props;

return (
<>
<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<ToastContainer/>
<div className="container-fluid">



<div className="row">
<div className="col-lg-3 col-md-4">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available Permission</span>
<h3 className="mb-0">

<span className="counter">	 {setcount}</span>
</h3>
</div>
<div className="w_chart">
<div id="mini-bar-chart1" className="mini-bar-chart" />
</div>
</div>
</div>

</div>



</div>

<form onSubmit={handleSubmit}>
<div className="col-lg-12 col-md-12">
<div className="card" >
<div className="card-body">
<div className="row clearfix">
<div className="col-lg-4 col-md-12">
<label>Permission Date</label>
<div className="form-group">
<select  className="form-control custom-select required-input" id="permission_date"   name='permission_date'   value={formData.permission_date} onChange={handleChange}>
        <option value="" disabled>Select Date</option>
        {setform.map(option => (
          <option key={option.value} value={option.label}>
            {option.label}
          </option>
        ))}



     {/* <option>2024-12-05</option>
     <option>2024-12-06</option>
     <option>2024-12-07</option>
     <option>2024-12-08</option> */}
      </select>
<div className="input-group" >
{/* <Datepicker></Datepicker> */}
</div>
</div>
</div>
<div className="col-lg-4 col-md-12">
<label>Permission Hour</label>
<div className="form-group">


<select  className="form-control custom-select required-input" id="permission_hours"   name='permission_hours' value={formData.permission_hours}  onChange={handleChange}>
        Permission<option value="" disabled>Select Hours</option>
     
        {sethour.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
))}


     
      </select>
</div>
</div>
<div className="col-lg-4 col-md-12">
<div className="form-group">
<label>Permission Type</label>


<select  className="form-control custom-select required-input" id="permission_status"   name='permission_status' value={formData.permission_status} onChange={handleChange}>
        <option value="" disabled>Select Type</option>
        {settype.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}



        {/* {options.map(option => (
          <option key={option.leave_type_id} value={option.leave_type_id}>
            {option.type_name}
          </option>
        ))} */}
      </select>

</div>
</div>
<div className="col-lg-12 col-md-12">
<label>Reason</label>
<div className="form-group">
<textarea
rows={4}
type="text"
className="form-control required-input"
placeholder="Reason"
name="reason" value={formData.reason} onChange={handleChange}
/>
</div>
</div>
</div>
<button type="submit" className="btn btn-round btn-primary">
Save
</button>

</div>

</div>


</div>

</form>

</div>
</div>
<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
<div className="card-header">
<h3 className="card-title">permission List</h3>

</div>
<div className="card-body">
<div className="table-responsive">
<DataTable
  columns={columns}
  data={Array.isArray(table) ? table : []}
  pagination
  striped
  highlightOnHover
  responsive
  persistTableHead
/>
{/* <p>{data}</p> */}
</div>
</div>
</div>
</div>

</div>
</div>
</div>

</div>
</div>

</>
);
}


export default Permission;